const defaultState = {
    mobile: false,
    landscape: undefined
};

export default function browser(state = defaultState, action) {
    if (action.type === 'ORIENTATION_CHANGE' && state.landscape !== action.landscape) {
        return {
            ...state,
            landscape: action.landscape
        }
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/browser.js